// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4798":"ad6c79d055ff82b8","9890":"1ddd3dff4d99b741"}[chunkId] + ".js";
};